var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{staticClass:"floating-action-button-component",attrs:{"slot":"activator","color":_vm.color,"fab":""},slot:"activator"},[_c('Avatar',[_vm._t("icon")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }